import React from 'react';
import { TableRow } from '@mui/material';
import { FormInput } from '~/components/FormComponents/FormInput.tsx';
import { FinancialConditionTableCell } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/shared/FinancialConditionTableCell.tsx';
import { FinancialConditionTableDeleteCell } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/shared/FinancialConditionTableDeleteCell.tsx';
import type { IIncomeBreakdownRowProps } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/incomeBreakdowns/types.ts';
import { FINANCIAL_CONDITION_FIELD_LABELS } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/constants.ts';
import {
  normalizeBalanceLine,
  normalizeDecimalValue,
  normalizePercentageValue,
  validateBalanceLine,
} from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/utils.ts';
import { documentGenerationFormStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/styles.ts';
import { financialConditionTableFieldStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/styles.ts';

export const IncomeBreakdownRow: React.FC<IIncomeBreakdownRowProps> = ({
  index,
  canRemove,
  disabled,
  onRemove,
}) => (
  <TableRow>
    <FinancialConditionTableCell>
      <FormInput
        name={`incomeBreakdowns.${index}.counterpartyName`}
        label="Найменування контрагента"
        disabled={disabled}
        fullWidth
        sx={documentGenerationFormStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormInput
        name={`incomeBreakdowns.${index}.counterpartyEdrpou`}
        label="ЄДРПОУ контрагента"
        type="text"
        inputProps={{ inputMode: 'numeric' }}
        disabled={disabled}
        fullWidth
        sx={documentGenerationFormStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormInput
        name={`incomeBreakdowns.${index}.reportLine`}
        label={FINANCIAL_CONDITION_FIELD_LABELS.reportLine}
        placeholder="р.1550"
        normalizeOnBlur={normalizeBalanceLine}
        rules={{ validate: validateBalanceLine }}
        inputProps={{ inputMode: 'numeric', maxLength: 6 }}
        disabled={disabled}
        fullWidth
        sx={financialConditionTableFieldStyles.reportLineField}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormInput
        name={`incomeBreakdowns.${index}.incomeType`}
        label="Складова (вид) доходу"
        disabled={disabled}
        fullWidth
        sx={documentGenerationFormStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormInput
        name={`incomeBreakdowns.${index}.amount`}
        label="Сума, тис. грн"
        type="text"
        inputProps={{ inputMode: 'decimal' }}
        normalizeOnBlur={normalizeDecimalValue}
        disabled={disabled}
        fullWidth
        sx={documentGenerationFormStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableCell>
      <FormInput
        name={`incomeBreakdowns.${index}.sharePercent`}
        label={FINANCIAL_CONDITION_FIELD_LABELS.sharePercent}
        type="text"
        inputProps={{ inputMode: 'decimal' }}
        normalizeOnBlur={normalizePercentageValue}
        disabled={disabled}
        fullWidth
        sx={documentGenerationFormStyles.field}
      />
    </FinancialConditionTableCell>
    <FinancialConditionTableDeleteCell
      label={`Видалити дохід ${index + 1}`}
      disabled={disabled}
      hidden={!canRemove}
      onDelete={onRemove}
    />
  </TableRow>
);
